
    var riot = require('riot')
    riot.tag2('gb-refinement-crumb', '<a onclick="{remove}">&times;</a> <b>{$navigation.displayName}: {$breadcrumbs.toView($refinement)}</b>', '', '', function(opts) {
    this.remove = () => this.$breadcrumbs.remove(this.$refinement, this.$navigation);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/breadcrumbs/gb-refinement-crumb.tag.html